import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({ref:"copylabel",staticClass:"copylabel faster",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copy.apply(null, arguments)}}},on),[_vm._v(_vm._s(_vm.text))])]}}])},[_c('span',[_vm._v("Copy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }